// src/routes/ask/$conversationId.tsx
// /ask/$conversationId — redirects to /agent (canvas-only cleanup).
// Old text-mode conversation links are forwarded to the agent surface.
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/ask/$conversationId')({
  beforeLoad: () => {
    throw redirect({ to: '/agent', replace: true, search: { q: undefined } })
  },
})
